import React from 'react'
import { Link } from 'react-router-dom'

export default function AboutFeatures() {
  return (
    <>
      <section className="about-features">
        <div className="container">
          {/* <div className="row align-items-center">
            <div className="col-md-6">
              <div className="about-image">
                <img src="/assets/images/growth-image1.webp" alt="Growth" className="img-responsive" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content">
                <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                  <span className="gradient-color">Grow Responsibly</span>
                  <h3 className="heading">We Are Committed To Sustainable Growth</h3>
                  <p>We pursue sustainable growth through systematic operations, resource-efficient processes, and lasting partnerships that minimize waste while maximizing performance. Our approach delivers consistent operational excellence, reduced environmental impact, and scalable laundry solutions built for long-term reliability across diverse industries.</p>
                  <Link className="default-btn " to="/heathcare-medical-grade-commercial-laundry"><span>See how</span></Link>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row align-items-center row-reverse">
            <div className="col-md-6">
              <div className="about-image">
                <img src="/assets/images/growth-image3.webp" alt="Growth" className="img-responsive" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content">
                <div className="wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                  <span className="gradient-color">Innovate Boldly</span>
                  <h3 className="heading">Powering Transformation Through Technology</h3>
                  <p>We leverage intelligent automation, systematic frameworks, and operational analytics to modernize laundry facilities, enhance efficiency, optimize resource utilization, and deliver predictable, high-performance solutions that help businesses maintain control, reduce costs, and expand operations seamlessly in competitive commercial environments.</p>
                  <Link className="default-btn " to="/about" ><span>Learn more</span></Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="about-image">
                <img src="/assets/images/growth-image2.webp" alt="Growth" className="img-responsive" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content">
                <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                  <span className="gradient-color">Generations of Excellence</span>
                  <h3 className="heading">35+ Years Of Trusted Family Excellence</h3>
                  <p>For over 35+ years, Supershine has combined founding principles with operational excellence, delivering reliable, quality-driven commercial laundry solutions. Our heritage of integrity, proven expertise, and consistent performance ensures exceptional service for growing businesses nationwide, today and for decades ahead.</p>
                  <Link className="default-btn " to="/about"><span>Explore Excellence</span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
